import React from "react";
import { Header } from "../../types";
import styles from "./EntityTable.module.css";
import { Dispatch, SetStateAction } from "react";
import { useNavigate } from "react-router-dom";

interface DataRow {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  role_id: string;
  status: number;
  location: string;
  event_date: string;
  competition: string;
  title: string;
  event: string;
  start_time: string;
  end_time: string;
  description: string;
  start_date: string;
  end_date: string;
  skills_abhs?: number;
  skills_abhs_mod2?: number;
  [key: string]: any;
}

interface EntityTableProps {
  headers: Header[];
  data: DataRow[];
  onDelete?: (entityId: string) => Promise<void>; // Add the onDelete function signature
  onEdit: (row: DataRow) => void;
  setCurrentEntityId: Dispatch<SetStateAction<string>>;
  //onStatusChange?: (userId: string, status: number) => Promise<void>; // API for status toggle
  onStatusChange?: (userId: string, status: number) => void; // API for status toggle

onSkillAbhsToggle?: (userId: string) => void;
onSkillMod2Toggle?: (userId: string) => void;

  haveButton: boolean;
  buttonName?: string;
  buttonLink?: string;
  editBtn?: boolean;
  activateBtn?: boolean;
}

const EntityTable: React.FC<EntityTableProps> = ({
  headers,
  data,
  onEdit,
  setCurrentEntityId,
  onStatusChange,
  onSkillAbhsToggle,
  onSkillMod2Toggle,
  haveButton,
  buttonName,
  buttonLink,
  editBtn = true,
  activateBtn= true,
}) => {
  const navigate = useNavigate();

  if (data.length === 0) {
    return <p>No data found</p>;
  }

  return (
    <table className={styles.entityTable}>
      <thead className={styles.entityTable__header}>
        <tr className={styles.entityTable__row}>
          {headers.map((header, index) => (
            <th className={styles.entityTable__head} key={index}>
              {header.label}
            </th>
          ))}
          <th className={styles.entityTable__head}>Actions</th>
          <th className={styles.entityTable__head}>ABHS</th>
          <th className={styles.entityTable__head}>MOD2</th>
        </tr>
      </thead>
      <tbody>
        {data.map((row: DataRow) => (
          <tr className={styles.entityTable__row} key={row.id}>
            {headers.map((header, cellIndex) => (
              <td className={styles.entityTable__column} key={cellIndex}>
                {row[header.key]}
              </td>
            ))}
            <td
              className={`${styles.entityTable__column} ${styles.entityTable__actionColumn}`}
            >
              {haveButton ? (
                <button
                  className={styles.entityTable__btn}
                  onClick={() => navigate(`${buttonLink}${row.id}`)}
                >
                  {buttonName}
                </button>
              ) : null}
              {editBtn ? (
                <button
                  className={styles.entityTable__btn}
                  onClick={() => {
                    setCurrentEntityId(row.id);
                    onEdit(row);
                    window.scrollTo({
                      top: 0,
                      behavior: "smooth",
                    });
                  }}
                >
                  Edit
                </button>
              ) : null}
              {activateBtn ? (
                <button
                  className={styles.entityTable__btn}
                  onClick={() => {
                    if (onStatusChange) {
                      onStatusChange(row.id, row.status === 1 ? 0 : 1);
                    }
                  }}                
                >
                  {row.status === 1 ? "Deactivate" : "Activate"}
                </button>
              ) : null}
            </td>

            <td className={styles.entityTable__column}>
              {onSkillAbhsToggle && (parseInt(row.role_id) == 3) ? (
                <label className={styles.switch}>
                  <input
                    type="checkbox"
                    checked={row.skills_abhs === 1}
                    onChange={() => onSkillAbhsToggle(row.id)}
                  />
                  <span className={styles.slider}></span>
                </label>
              ) : ""}
            </td>
            <td className={styles.entityTable__column}>
              {onSkillMod2Toggle && (parseInt(row.role_id) == 3) ? (
                <label className={styles.switch}>
                  <input
                    type="checkbox"
                    checked={row.skills_abhs_mod2 === 1}
                    onChange={() => onSkillMod2Toggle(row.id)}
                  />
                  <span className={styles.slider}></span>
                </label>
              ) : ""}
            </td>

          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default EntityTable;